var $imageHover = document.querySelectorAll('[data-src-hover]');
$imageHover === null || $imageHover === void 0 ? void 0 : $imageHover.forEach(function($item) {
    var src = $item.getAttribute('src');
    var srcHover = $item.dataset.srcHover;
    $item.addEventListener('mouseenter', function() {
        $item.setAttribute('src', srcHover);
    });
    $item.addEventListener('mouseleave', function() {
        $item.setAttribute('src', src);
    });
});
var $videoHover = document.querySelectorAll('[data-video-hover]');
$videoHover === null || $videoHover === void 0 ? void 0 : $videoHover.forEach(function($item) {
    var $video = $item.querySelector('video');
    $item.addEventListener('mouseenter', function() {
        $video.play();
    });
    $item.addEventListener('mouseleave', function() {
        $video.pause();
    });
});
